module.exports = __webpack_public_path__ + "static/media/spiral_logo.a55bc90b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/details/imgs/spiral_logo.png
// module id = 1159
// module chunks = 0